module.exports = __webpack_public_path__ + "static/img/img_bg_01.974187d1.png";